import { createAction, handleActions } from 'redux-actions';
import { _getAttendantList, _addNewAttendant, _editAttendant, _getAttendantDetails, _getActiveServiceTypesList, _getActiveAddOnServicesList, _getActivePetTypesList, _getPetSizesList, _getActivePetDetails, _deletAttendant, _getAllActiveVenuesList } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';

const initialState = {
  attendant_list: { loading: false, response: [], hasError: false, error: {} },
  active_service_types: { loading: false, response: [], hasError: false, error: {} },
  active_add_on_services: { loading: false, response: [], hasError: false, error: {} },
  pet_types: { loading: false, response: [], hasError: false, error: {} },
  pet_sizes: { loading: false, response: [], hasError: false, error: {} },
  pet_details: { loading: false, response: {}, hasError: false, error: {} },
  attendant: { loading: false, response: {}, hasError: false, error: {} },
  attendant_detail: { loading: false, response: {}, hasError: false, error: {} },
  delete_attendant: { loading: false, response: {}, hasError: false, error: {} },
};

export const getAttendantListStart = createAction(ActionTypes.GET_ATTENDANT_LIST);
export const getAttendantListSuccess = createAction(ActionTypes.GET_ATTENDANT_LIST_SUCCESS, response => response);
export const getAttendantListError = createAction(ActionTypes.GET_ATTENDANT_LIST_ERROR, error => error);

export const getAttendantList = (page = '', pageSize, searchQuery) => (dispatch) => {
  dispatch(getAttendantListStart());
  return _getAttendantList(page, pageSize, searchQuery).then((response) => {
    dispatch(getAttendantListSuccess(response));
  }).catch((error) => {
    dispatch(getAttendantListError(error));
  });
};

export const editAttendantStart = createAction(ActionTypes.UPDATE_ATTENDANT_DETAILS);
export const editAttendantSuccess = createAction(ActionTypes.UPDATE_ATTENDANT_DETAILS_SUCCESS, response => response);
export const editAttendantError = createAction(ActionTypes.UPDATE_ATTENDANT_DETAILS_ERROR, error => error);

export const editAttendant = (params, id) => (dispatch) => {
  dispatch(editAttendantStart());
  return _editAttendant(params, id).then((response) => {
    dispatch(editAttendantSuccess(response));
  }).catch((error) => {
    dispatch(editAttendantError(error));
  });
};

export const getAttendantDetailsStart = createAction(ActionTypes.GET_ATTENDANT_DETAILS);
export const getAttendantDetailsSuccess = createAction(ActionTypes.GET_ATTENDANT_DETAILS_SUCCESS, response => response);
export const getAttendantDetailsError = createAction(ActionTypes.GET_ATTENDANT_DETAILS_ERROR, error => error);

export const getAttendantDetails = (id) => (dispatch) => {
  dispatch(getAttendantDetailsStart());
  return _getAttendantDetails(id).then((response) => {
    dispatch(getAttendantDetailsSuccess(response));
  }).catch((error) => {
    dispatch(getAttendantDetailsError(error));
  });
};

export const getPetDetailsStart = createAction(ActionTypes.GET_PET_DETAILS);
export const getPetDetailsSuccess = createAction(ActionTypes.GET_PET_DETAILS_SUCCESS, response => response);
export const getPetDetailsError = createAction(ActionTypes.GET_PET_DETAILS_ERROR, error => error);

export const getActivePetDetails = (id) => (dispatch) => {
  dispatch(getPetDetailsStart());
  return _getActivePetDetails(id).then((response) => {
    dispatch(getPetDetailsSuccess(response));
  }).catch((error) => {
    dispatch(getPetDetailsError(error));
  });
};

export const getPetSizesListStart = createAction(ActionTypes.GET_PET_SIZES_LIST);
export const getPetSizesListSuccess = createAction(ActionTypes.GET_PET_SIZES_LIST_SUCCESS, response => response);
export const getPetSizesListError = createAction(ActionTypes.GET_PET_SIZES_LIST_ERROR, error => error);

export const getPetSizesList = (petId) => (dispatch) => {
  dispatch(getPetSizesListStart());
  return _getPetSizesList(petId).then((response) => {
    dispatch(getPetSizesListSuccess(response));
  }).catch((error) => {
    dispatch(getPetSizesListError(error));
  });
};

export const getActivePetTypesListStart = createAction(ActionTypes.GET_ACTIVE_PET_TYPES_LIST);
export const getActivePetTypesListSuccess = createAction(ActionTypes.GET_ACTIVE_PET_TYPES_LIST_SUCCESS, response => response);
export const getActivePetTypesListError = createAction(ActionTypes.GET_ACTIVE_PET_TYPES_LIST_ERROR, error => error);

export const getActivePetTypesList = (page = '', pageSize) => (dispatch) => {
  dispatch(getActivePetTypesListStart());
  return _getActivePetTypesList(page, pageSize).then((response) => {
    dispatch(getActivePetTypesListSuccess(response));
  }).catch((error) => {
    dispatch(getActivePetTypesListError(error));
  });
};

export const getActiveServiceTypesListStart = createAction(ActionTypes.GET_ACTIVE_SERVICE_TYPES_LIST);
export const getActiveServiceTypesListSuccess = createAction(ActionTypes.GET_ACTIVE_SERVICE_TYPES_LIST_SUCCESS, response => response);
export const getActiveServiceTypesListError = createAction(ActionTypes.GET_ACTIVE_SERVICE_TYPES_LIST_ERROR, error => error);

export const getActiveServiceTypesList = (page = '') => (dispatch) => {
  dispatch(getActiveServiceTypesListStart());
  return _getActiveServiceTypesList(page).then((response) => {
    dispatch(getActiveServiceTypesListSuccess(response));
  }).catch((error) => {
    dispatch(getActiveServiceTypesListError(error));
  });
};

export const getActiveAddOnServicesListStart = createAction(ActionTypes.GET_ACTIVE_ADD_ON_SERVICE_LIST);
export const getActiveAddOnServicesListSuccess = createAction(ActionTypes.GET_ACTIVE_ADD_ON_SERVICE_LIST_SUCCESS, response => response);
export const getActiveAddOnServicesListError = createAction(ActionTypes.GET_ACTIVE_ADD_ON_SERVICE_LIST_ERROR, error => error);

export const getActiveAddOnServicesList = (page = '') => (dispatch) => {
  dispatch(getActiveAddOnServicesListStart());
  return _getActiveAddOnServicesList(page).then((response) => { 
    dispatch(getActiveAddOnServicesListSuccess(response));
  }).catch((error) => {
    dispatch(getActiveAddOnServicesListError(error));
  });
};

export const getAllActiveVenuesListStart = createAction(ActionTypes.GET_ALL_ACTIVE_VENUES_LIST);
export const getAllActiveVenuesListSuccess = createAction(ActionTypes.GET_ALL_ACTIVE_VENUES_LIST_SUCCESS, response => response);
export const getAllActiveVenuesListError = createAction(ActionTypes.GET_ALL_ACTIVE_VENUES_LIST_ERROR, error => error);

export const getAllActiveVenuesList = (filter = '') => (dispatch) => {
  dispatch(getAllActiveVenuesListStart());
  return _getAllActiveVenuesList(filter).then((response) => {
    dispatch(getAllActiveVenuesListSuccess(response));
  }).catch((error) => {
    dispatch(getAllActiveVenuesListError(error));
  });
};

export const addNewAttendantStart = createAction(ActionTypes.ADD_NEW_ATTENDANT);
export const addNewAttendantSuccess = createAction(ActionTypes.ADD_NEW_ATTENDANT_SUCCESS, response => response);
export const addNewAttendantError = createAction(ActionTypes.ADD_NEW_ATTENDANT_ERROR, error => error);

export const addNewAttendant = (params) => (dispatch) => {
  dispatch(addNewAttendantStart());
  return _addNewAttendant(params).then((response) => {
    dispatch(addNewAttendantSuccess(response));
  }).catch((error) => {
    dispatch(addNewAttendantError(error));
  });
};

export const deletAttendantStart = createAction(ActionTypes.DELETE_ATTENDANT);
export const deletAttendantSuccess = createAction(ActionTypes.DELETE_ATTENDANT_SUCCESS, response => response);
export const deletAttendantError = createAction(ActionTypes.DELETE_ATTENDANT_ERROR, error => error);

export const deletAttendant = (id) => (dispatch) => {
  dispatch(deletAttendantStart());
  return _deletAttendant(id).then((response) => {
    dispatch(deletAttendantSuccess(response));
  }).catch((error) => {
    dispatch(deletAttendantError(error));
  });
};

const reducer = handleActions({
  //ATTENDANT_LIST
  [ActionTypes.GET_ATTENDANT_LIST]: (state) => ({
    ...state, attendant_list: {
      ...state.attendant_list,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ATTENDANT_LIST_SUCCESS]: (state, action) => ({
    ...state,
    attendant_list: {
      ...state.attendant_list,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ATTENDANT_LIST_ERROR]: (state, action) => ({
    ...state,
    attendant_list: {
      ...state.attendant_list,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //ACTIVE_SERVICE_TYPES_LIST
  [ActionTypes.GET_ACTIVE_SERVICE_TYPES_LIST]: (state) => ({
    ...state, active_service_types: {
      ...state.active_service_types,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_SERVICE_TYPES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    active_service_types: {
      ...state.active_service_types,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_SERVICE_TYPES_LIST_ERROR]: (state, action) => ({
    ...state,
    active_service_types: {
      ...state.active_service_types,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  // ACTIVE_ADD_ON_SERVICE_LIST
  [ActionTypes.GET_ACTIVE_ADD_ON_SERVICE_LIST]: (state) => ({
    ...state, active_add_on_services: {
      ...state.active_add_on_services,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_ADD_ON_SERVICE_LIST_SUCCESS]: (state, action) => ({
    ...state,
    active_add_on_services: {
      ...state.active_add_on_services,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_ADD_ON_SERVICE_LIST_ERROR]: (state, action) => ({
    ...state,
    active_add_on_services: {
      ...state.active_add_on_services,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //ACTIVE_PET_TYPES_LIST
  [ActionTypes.GET_ACTIVE_PET_TYPES_LIST]: (state) => ({
    ...state, pet_types: {
      ...state.pet_types,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_PET_TYPES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    pet_types: {
      ...state.pet_types,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_PET_TYPES_LIST_ERROR]: (state, action) => ({
    ...state,
    pet_types: {
      ...state.pet_types,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //PET_SIZES_LIST
  [ActionTypes.GET_PET_SIZES_LIST]: (state) => ({
    ...state, pet_sizes: {
      ...state.pet_sizes,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_PET_SIZES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    pet_sizes: {
      ...state.pet_sizes,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_PET_SIZES_LIST_ERROR]: (state, action) => ({
    ...state,
    pet_sizes: {
      ...state.pet_sizes,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //GET_PET_DETAILS
  [ActionTypes.GET_PET_DETAILS]: (state) => ({
    ...state, pet_details: {
      ...state.pet_details,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_PET_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    pet_details: {
      ...state.pet_details,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_PET_DETAILS_ERROR]: (state, action) => ({
    ...state,
    pet_details: {
      ...state.pet_details,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //ADD_NEW_ATTENDANT
  [ActionTypes.ADD_NEW_ATTENDANT]: (state) => ({
    ...state,
    attendant: {
      ...state.attendant,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.ADD_NEW_ATTENDANT_SUCCESS]: (state, action) => ({
    ...state,
    attendant: {
      ...state.attendant,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.ADD_NEW_ATTENDANT_ERROR]: (state, action) => ({
    ...state,
    attendant: {
      ...state.attendant,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //GET_ATTENDANT_DETAILS
  [ActionTypes.GET_ATTENDANT_DETAILS]: (state) => ({
    ...state,
    attendant_detail: {
      ...state.attendant_detail,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ATTENDANT_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    attendant_detail: {
      ...state.attendant_detail,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ATTENDANT_DETAILS_ERROR]: (state, action) => ({
    ...state,
    attendant_detail: {
      ...state.attendant_detail,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //UPDATE_ATTENDANT
  [ActionTypes.UPDATE_ATTENDANT_DETAILS]: (state) => ({
    ...state,
    attendant_detail: {
      ...state.attendant_detail,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.UPDATE_ATTENDANT_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    attendant_detail: {
      ...state.attendant_detail,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.UPDATE_ATTENDANT_DETAILS_ERROR]: (state, action) => ({
    ...state,
    attendant_detail: {
      ...state.attendant_detail,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //DELETE_ATTENDANT
  [ActionTypes.DELETE_ATTENDANT]: (state) => ({
    ...state,
    delete_attendant: {
      ...state.delete_attendant,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.DELETE_ATTENDANT_SUCCESS]: (state, action) => ({
    ...state,
    delete_attendant: {
      ...state.delete_attendant,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.DELETE_ATTENDANT_ERROR]: (state, action) => ({
    ...state,
    delete_attendant: {
      ...state.delete_attendant,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
}, initialState);

export default reducer;